<template>
  <el-button v-bind="$attrs" @click="click">
    <slot></slot>
  </el-button>
</template>

<script>
import { debounce } from 'lodash';

export default {
  emit: ['click'],
  props: {
    time: {
      type: Number,
      default: 500
    }
  },
  computed: {
    click() {
      return debounce(() => {
        this.$emit('click', ...arguments)
      }, this.time, { leading: true, trailing: false })
    }
  }
}
</script>

<style lang="scss" scoped></style>